<div
  fxLayout="column"
  fxFlexAlign="space-around flex-start"
  class="confirmation-wrapper p-40"
>
  <div class="text-wrapper mb-50">
    <div class="title text-yellow font-22 bold font-chakra">
      {{ data?.titleTranslation | translate }}
    </div>
    <div class="message text-gray font-15 mt-15"
      [innerHTML]="data?.messageTranslation | translate: data?.messageParams">
    </div>
  </div>
  <div
    fxLayout="row"
    fxFlexAlign="center center"
    class="actions-wrapper w-full"
  >
    <button mat-dialog-close class="cancel-btn px-50" mat-raised-button>
      {{ 'general.cancel' | translate | uppercase }}
    </button>
    <button
      [mat-dialog-close]="true"
      class="aum-button px-50"
      color="primary"
      mat-raised-button
    >
      {{ 'general.yes' | translate | uppercase }}
    </button>
  </div>
</div>
